import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BrandService } from '../brand/brand.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {
  @Input() title: string;
  @Input() visible: string;
  @Input() body_content: string;
  @Input() button_text: string;
  @Output() ok_button_event: EventEmitter<any> = new EventEmitter();
  brand = this.brandService.brand;
  constructor(private brandService: BrandService) { }

  ngOnInit() {
  }

  popupOkAction(){
    this.visible = 'none';
    this.ok_button_event.emit()
  }
}
